import { isNullOrWhiteSpace } from 'data/string';
import { ToastType } from 'modules/application/misc/ToastService';
export const validateScheduledDate = (scheduleDate, scheduleTime, blipToastService, translate) => {
    if (isNullOrWhiteSpace(scheduleDate) || isNullOrWhiteSpace(scheduleTime)) {
        showToast('activeMessages.scheduleMessageDateErrorTitle', 'activeMessages.send.send.scheduleFeature.errorMessageInvalidDateTime', blipToastService, translate);
        return false;
    }
    const informedDate = new Date(scheduleDate + ' ' + scheduleTime);
    if (informedDate <= new Date()) {
        showToast('activeMessages.scheduleMessageDateErrorTitlePastDateTime', 'activeMessages.send.send.scheduleFeature.errorMessagePastDateTime', blipToastService, translate);
        return false;
    }
    if (informedDate >= getLimitDate()) {
        showToast('activeMessages.scheduleMessageDateErrorTitleFutureDateTime', 'activeMessages.send.send.scheduleFeature.errorMessageFutureDateTime', blipToastService, translate);
        return false;
    }
    return true;
};
const showToast = async (title, message, blipToastService, translate) => {
    blipToastService.show(ToastType.Danger, {
        title: await translate(title),
        msg: await translate(message),
    });
};
const getLimitDate = () => {
    const limitDate = new Date();
    limitDate.setFullYear(limitDate.getFullYear() + 1);
    return limitDate;
};
